<template>
  <div class="newsList px-360">
    <div class="nav">
    <div class="AList" v-if="ifShowA">
      <BC :msg1="location[0]" class="hidden-xs-only"></BC>

      <el-tabs v-model="activeName" @tab-click="handleClick" class="eyTab">
          <el-tab-pane label="全部新闻" name="first">
            <vue-element-loading :active="loading" spinner="ring" color="#2563AF"/>
            <div class="eyNews" v-if="newsList && newsList.length !== 0">
              <div class="content" id="getAList" ref="allNum" v-for="(item,index) in newsList" :key="index" @click="goDetailAndSetStore({id:item.newsId,type:'0'})">
                <div class="main-flex">
                  <div class="left"><img :src="'/else'+item.newsImg" alt=""></div>
                  <div class="right">
                    <h4 class="title-cut">{{item.newsTitle}}</h4>
                    <p class="hidden-xs-only">{{item.newsIntro}}</p>
                    <div class="eyDetail">
                      <p class="a">详情 <span>>></span></p>
                      <div>
                        <i class="el-icon-date hidden-xs-only"></i><span>{{timeSub[index]}}</span>
                        <i class="el-icon-edit-outline hidden-xs-only"></i><span class="hidden-xs-only">{{item.createBy}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
              </div>
              <PageTab :totalPage="allPage" :newsType="'0'" :currentPage="currentPage" @changePage="changePage(arguments)" class="hidden-xs-only"></PageTab>
              <button class="moreBu hidden-sm-and-up" :class="moreAll=='查看更多'?'':onlyText" @click="moreAll=='查看更多'?newsAdd(0):false">{{moreAll}} <i v-show="moreAll=='查看更多'?true:false" ref="ti1" class="el-icon-arrow-down"></i></button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="公司新闻" name="second">
            <vue-element-loading :active="loading" spinner="ring" color="#2563AF"/>
            <div class="eyNews" v-if="newsList && newsList.length !== 0">
              <div class="content" id="getAList" ref="comNum" v-for="(item,index) in newsList" :key="index" @click="goDetailAndSetStore({id:item.newsId,type:item.newsType})">
                <div class="main-flex">
                  <div class="left"><img :src="'/else'+item.newsImg" alt=""></div>
                  <div class="right">
                    <h4>{{item.newsTitle}}</h4>
                    <p class="hidden-xs-only">{{item.newsIntro}}</p>
                    <div class="eyDetail">
                      <p>详情 <span>>></span></p>
                      <div>
                        <i class="el-icon-date hidden-xs-only"></i><span>{{timeSub[index]}}</span>
                        <i class="el-icon-edit-outline hidden-xs-only"></i><span class="hidden-xs-only">{{item.createBy}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
              </div>
              <PageTab :totalPage="allPage" :newsType="'1'" :currentPage="currentPage" @changePage="changePage(arguments)" class="hidden-xs-only"></PageTab>
              <button class="moreBu hidden-sm-and-up" :class="moreCom=='查看更多'?'':onlyText" @click="moreCom=='查看更多'?newsAdd(1):false">{{moreCom}} <i v-show="moreCom=='查看更多'?true:false" ref="ti2" class="el-icon-arrow-down"></i></button>
              
            </div>
          </el-tab-pane>
          <el-tab-pane label="行业资讯" name="third">
            <vue-element-loading :active="loading" spinner="ring" color="#2563AF"/>
            <div class="eyNews" v-if="newsList && newsList.length !== 0">
              <div class="content" id="getAList" ref="busNum" v-for="(item,index) in newsList" :key="index" @click="goDetailAndSetStore({id:item.newsId,type:item.newsType})">
                <div class="main-flex">
                  <div class="left"><img :src="'/else'+item.newsImg" alt=""></div>
                  <div class="right">
                    <h4>{{item.newsTitle}}</h4>
                    <p class="hidden-xs-only">{{item.newsIntro}}</p>
                    <div class="eyDetail">
                      <p>详情 <span>>></span></p>
                      <div>
                        <i class="el-icon-date hidden-xs-only"></i><span>{{timeSub[index]}}</span>
                        <i class="el-icon-edit-outline hidden-xs-only"></i><span class="hidden-xs-only">{{item.createBy}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
              </div>
              <PageTab :totalPage="allPage" :newsType="'2'" :currentPage="currentPage" @changePage="changePage(arguments)" class="hidden-xs-only"></PageTab>
              <button class="moreBu hidden-sm-and-up" :class="moreBus=='查看更多'?'':onlyText" @click="moreBus=='查看更多'?newsAdd(2):false">{{moreBus}} <i v-show="moreBus=='查看更多'?true:false" ref="ti3" class="el-icon-arrow-down"></i></button>
            </div>
          </el-tab-pane>
        </el-tabs>
    </div>
    
    <div class="newsDetail" v-if="ifShowB">
      <BC :msg1="wWidth<768?location[1]:location[0]" :msg2="locationAfter" @changeShow="pShow" class="detailBC"></BC>

      <h4>{{newsDetail.newsDetail.newsTitle}}</h4>
      <p class="timeAndRemark">发布时间：{{newsDetail.newsDetail.createTime}}<span class="hidden-xs-only">发布人：{{newsDetail.newsDetail.createBy}}</span></p>
      <div class="content" ref="editor" v-html="newsDetail.newsDetail.newsContent"></div>
      <hr class="hidden-xs-only">
      <div class="xs-button">
        <p class="previous" @click="newsDetail.beforeDetail.createTime == null?false:go_detail({id:newsDetail.beforeDetail.newsId,type:newsType})">上一篇<span class="hidden-xs-only">：{{newsDetail.beforeDetail.newsTitle}}</span><span class="time hidden-xs-only">{{newsDetail.beforeDetail.createTime}}</span></p>
        <p class="next" @click="newsDetail.nextDetail.createTime == null?false:go_detail({id:newsDetail.nextDetail.newsId,type:newsType})">下一篇<span class="hidden-xs-only">：{{newsDetail.nextDetail.newsTitle}}</span><span class="time hidden-xs-only">{{newsDetail.nextDetail.createTime}}</span></p>
      </div>
      
    </div>
    
    </div>
  </div>
</template>

<script>
import BC from '@/components/bc.vue'
import PageTab from '@/components/page.vue'
import { changeKeywords ,changeDescription,changeTitle } from '@/js/tdk.js'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data(){
      return{
        location: ['新闻资讯','<'],
        activeName: 'first',
        currentPage: 1,
        locationAfter: '全部新闻',
        initLimit: 5,
        sumLimit: 5,
        moreAll: "查看更多",
        moreCom: "查看更多",
        moreBus: "查看更多",
        onlyText: "onlyTextCss",
        wWidth : window.screen.width,
      }
    },
    computed:{
      ...mapState({
        newsList: state => state.news.newsList,
        newsCount: state => state.news.newsCount,
        allPage: state => state.news.allPage,
        newsDetail: state => state.news.newsDetail,
        ifShowA: state => state.news.ifShowA,
        ifShowB: state => state.news.ifShowB,
        newsType: state => state.news.newsType,
        loading: state => state.news.loading,
      }),
      ...mapGetters({
        timeTrans: 'news/time_transfer',
        timeSub: 'news/time_sub',
      })
    },
    components:{
      BC,
      PageTab,
    },
    created(){
      this._get_newsList()

      if(this.ifShowB){
        this.$nextTick(this.replaceImgTag)
      }

      if (sessionStorage.getItem("store")!="undefined") {
        this.$store.replaceState(Object.assign({},this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
        if(this.ifShowB){
          this.$nextTick(this.replaceImgTag)
          changeTitle(this.newsDetail.newsDetail.newsTitle)
          changeKeywords(this.newsDetail.newsDetail.newsKeywords)
          changeDescription(this.newsDetail.newsDetail.newsIntro)
        }
      }

      window.addEventListener("beforeunload",()=>{
        if(this.$router.history.current.name == "news"){
          sessionStorage.setItem("store",JSON.stringify(this.$store.state))
        }
      })

      if(this.newsType == "0"){
        this.locationAfter = '全部新闻'
      }else if(this.newsType == "1"){
        this.locationAfter = '公司新闻'
      }else if(this.newsType == "2"){
        this.locationAfter = '行业资讯'
      }

    },
    updated(){
      if(this.ifShowB){
        this.$nextTick(this.replaceImgTag)
        changeTitle(this.newsDetail.newsDetail.newsTitle)
        changeKeywords(this.newsDetail.newsDetail.newsKeywords)
        changeDescription(this.newsDetail.newsDetail.newsIntro)
      }else{
        changeTitle('医影智能-新闻资讯')
        changeKeywords('医影智能，山东医影智能科技有限公司，虚拟仿真系统，医学影像中心VR系统，MRI虚拟仿真系统，CT虚拟仿真系统，DR虚拟仿真系统，MRI性能检测实验，CT性能检测实验，医学影像教学机，影像云平台，医学影像虚拟仿真教学平台')
        changeDescription('山东医影智能科技有限公司专注于医学影像虚拟仿真技术的研究，提供医学影像信息化解决方案。公司产品分为医学影像中心VR系统，MRI、CT、DR虚拟仿真系统，影像云平台，MRI、CT、DR教学设备等。')
      }

      if(this.ifShowA && this.wWidth<768){
        if(this.$refs.allNum && this.$refs.allNum.length == this.newsCount){
          this.moreAll = "已经到底啦~"
        }else{
          this.moreAll = "查看更多"
        }
        if(this.$refs.comNum && this.$refs.comNum.length == this.newsCount){
          this.moreCom = "已经到底啦~"
        }else{
          this.moreCom = "查看更多"
        }
        if(this.$refs.busNum && this.$refs.busNum.length == this.newsCount){
          this.moreBus = "已经到底啦~"
        }else{
          this.moreBus = "查看更多"
        }
      }

    },
    methods: {
      ...mapActions({
        get_newsList: 'news/get_and_change_newsList',
        go_detail: 'news/go_detail_from_list'
      }),

      _get_newsList(){
        this.get_newsList({
          limit: this.initLimit,
          type: "0",
          page: this.currentPage
        })
      },

      newsAdd(type){
        type = ""+type

        this.$store.commit('news/change_newsType',type)

        let ti = '';
        if(type == '0'){
          ti = this.$refs.ti1;
        }else if(type == '1'){
          ti = this.$refs.ti2;
        }else if(type == '2'){
          ti = this.$refs.ti3;
        }

        if(ti) {
          ti.className = ti.className.replace("el-icon-arrow-down","el-icon-loading")
        }

        this.sumLimit += this.initLimit

        let finish = this.get_newsList({
          limit: this.sumLimit,
          type: type,
          page: 1
        })

        finish.then(()=>{
          if(ti) {
            ti.className = ti.className.replace("el-icon-loading","el-icon-arrow-down")
          }
        })

      },

      goDetailAndSetStore(obj){
        
        this.$store.commit('news/change_newsType',obj.type)
        if(obj.type == "0"){
          this.locationAfter = '全部新闻'
        }else if(obj.type == "1"){
          this.locationAfter = '公司新闻'
        }else if(obj.type == "2"){
          this.locationAfter = '行业资讯'
        }
        
        if (sessionStorage.getItem("store")!="undefined") {
          this.$store.replaceState(Object.assign({},this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
        }
        sessionStorage.setItem("store",JSON.stringify(this.$store.state))

        this.go_detail(obj)
        
      },

      pShow(){
        let finish = this.get_newsList({
          limit: this.initLimit,
          type: this.newsType,
          page: this.currentPage
        })

        if(this.newsType == "0"){
          this.activeName = "first"
        }else if(this.newsType == "1"){
          this.activeName = "second"
        }else if(this.newsType == "2"){
          this.activeName = "third"
        }

        finish.then(()=>{
          this.$store.commit('news/change_ifShowA',true)
          this.$store.commit('news/change_ifShowB',false)
        })
      },

      handleClick(tab) {
        this.currentPage = 1

        this.$store.commit('news/change_loading',true)
        this.$store.commit('news/change_newsType',tab.index + "")

        let a = this.get_newsList({
          limit: this.initLimit,
          type: tab.index + "",
          page:this.currentPage
        })
        a.then(()=>{
          this.$store.commit('news/change_loading',false)
        })

      },

      changePage(arg) {
        this.currentPage = arg[0]

        this.$store.commit('news/change_loading',true)
        let finish = this.get_newsList({
          limit: this.initLimit,
          type:arg[1],
          page:this.currentPage
        })
        
        finish.then(()=>{
          this.$store.commit('news/change_loading',false)
        })
      },

      replaceImgTag(){
        let oEditor = this.$refs.editor
        if(!oEditor) return
        let content = oEditor.innerHTML

        const reg = /<p[^>]*><img[^>]*><\/p>/g
        const matchStr = content.match(reg)

        const strReg = /<img[^>]*>/g
        if(matchStr != null){
          let change = []

          matchStr.forEach((str) => {
            change.push(str.match(strReg))
          })

          let jreg = []

          change.forEach((str,i) => {
            jreg.push(new RegExp('<p[^>]*>'+str+'<\/p>'))
            content = content.replace(jreg[i],str[0])
          })
        }

        content = content.replace(/<p style="text-align: center;">/g,'<p style="text-align: center !important;">')
        oEditor.innerHTML = content
      },
      
    },
    mounted(){
    },
    beforeDestroyed(){
    },
    destroyed(){
      sessionStorage.removeItem("store")
      changeTitle
      changeKeywords
      changeDescription
    }
}
</script>

<style lang="scss" scoped>
.newsList{
  width: 100%;
  
  ::v-deep .velmld-spinner{
    top: 20%;
  }
  
  .nav {
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }    
  
  .AList{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 10px;
    
    .eyTab{
      margin-top: vw(22);

      .eyNews{
        .content{
          // ========== 卡片立体样式 ==========
          padding: vw(24);
          border-radius: vw(12);
          background: #ffffff;
          margin-bottom: vw(36);
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          overflow: hidden;
          position: relative;
          // 基础阴影 - 立体感
          box-shadow: 
            0 2px 4px rgba(0, 0, 0, 0.04),
            0 4px 8px rgba(0, 0, 0, 0.02),
            0 8px 16px rgba(37, 99, 175, 0.06);
          
          // 细微边框强调
          border: 1px solid rgba(37, 99, 175, 0.04);

          h4,p,span{
            font-size: vw(16);
          }

          >.main-flex{
            justify-content: flex-start;
            margin-bottom: vw(18);
          }

          h4,
          p{
            margin: 0;
          }

          .left{
            width: vw(313);
            height: vw(196);
            overflow: hidden;
            border-radius: vw(8);
            flex-shrink: 0;

            img{
              width: 100%;
              height: 100%;
              transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
              object-fit: cover;
            }
          }

          .right{
            padding: vw(8) vw(29) vw(13) vw(15);
            width: 100%;
            max-width: vw(874);
            height: vw(196);
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            position: relative;
            box-sizing: border-box;

            >p{
              margin: vw(16) 0;
              text-align: left;
              color: $font33;
              overflow: hidden;
              text-overflow: ellipsis;
              line-height: 1.7;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              display: -moz-box;
              -moz-line-clamp: 3;
              -moz-box-orient: vertical;
              word-wrap: break-word;
              word-break: break-all;
              transition: all 0.3s ease;
            }

            .eyDetail{
              p,
              >div{
                position: absolute;
                bottom: 0;
              }

              p{
                color: $yyBlue;
                font-weight: 500;
                transition: color 0.3s ease;

                span{
                  display: inline-block;
                  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
                }
              }

              >div{
                right: vw(29);

                i,
                span{
                  color: $font66;
                  transition: all 0.3s ease;
                }

                i{
                  padding-right: vw(4);
                }

                span{
                  &:first-of-type{
                    padding-right: 2rem;
                  }
                }
              }
            }
          }

          hr{
            height: 1px;
            margin: vw(20) 0 0;
            background-color: $grayE7;
            border: none;
            transition: all 0.3s ease;
          }

          // ========== Hover 立体效果（背景不溢出） ==========
          &:hover{
            cursor: pointer;
            // 多层阴影打造立体悬浮感
            box-shadow: 
              0 4px 8px rgba(37, 99, 175, 0.08),
              0 8px 24px rgba(37, 99, 175, 0.15),
              0 16px 48px rgba(37, 99, 175, 0.10),
              0 2px 4px rgba(37, 99, 175, 0.04);
            transform: translateY(-4px) scale(1.002);
            background: linear-gradient(145deg, #2563AF, #1d4f8f);
            border-color: #2563AF;

            // 内部元素颜色过渡（背景不溢出）
            .a {
              color: #ffffff !important;
            }

            .left {
              img {
                transform: scale(1.08) rotate(0.5deg);
              }
            }

            .right {
              >p {
                color: rgba(255, 255, 255, 0.95);
                transform: translateY(vw(4));
              }

              h4 {
                color: #ffffff;
              }

              .eyDetail {
                p {
                  color: rgba(255, 255, 255, 0.9);
                  
                  span {
                    transform: translateX(vw(6));
                    color: #ffffff;
                  }
                }

                >div {
                  i, span {
                    color: rgba(255, 255, 255, 0.8);
                  }
                }
              }
            }

            hr {
              background-color: rgba(255, 255, 255, 0.25);
            }
          }

          // 点击态反馈
          &:active {
            transform: translateY(-2px) scale(0.998);
            box-shadow: 
              0 2px 4px rgba(37, 99, 175, 0.06),
              0 4px 12px rgba(37, 99, 175, 0.10);
          }
        }
      }
    }

    ::v-deep {
      .el-tabs__header{
        margin-bottom: vw(50);

        .el-tabs__item{
          font-size: vw(18);
          padding: vw(5) vw(157);
          margin-right: vw(5);
          font-weight: 500;
          color: $black306;
          min-height: vw(50);
          transition: all 0.3s ease;

          &:hover,
          &.is-active{
            color: white;
            background: $yyBlue;
            border-radius: 0 vw(30) 0 0;
          }
        }

        .el-tabs__active-bar{
          display: none;
        }

        #tab-first{
          padding-left: vw(163);
        }

        #tab-third{
          padding-right: vw(166);
          margin-right: 0;
        }

        .el-tabs__nav-wrap::after{
          background-color: $yyBlue;
        }
      }
    }
  }

  .newsDetail{
    margin-bottom: vw(222);
    h4,p{
      margin: 0;
    }

    h4{
      font-size: vw(30);
      padding: vw(18) 0;
      margin-bottom: vw(15);
      border-bottom: 1px solid $grayE7;
    }

    .timeAndRemark{
      font-size: vw(16);
      color: $font66;
    }

    .content ::v-deep {
      margin: vw(30) 0;

      p{
        margin: vw(18) 0 !important;
        line-height: 2 !important;
      }

      p,
      p span{
        font-size: vw(18) !important;
        font-family: SourceHanSansCN-Normal !important;
        text-align: left !important;
      }

      em{
        display: block;
        margin-top: vw(-18);
        font-size: vw(16);
        font-style: normal;
        text-align: center;
      }
      
      img{
        max-width: vw(1200) !important;
        width: 60% !important;
        height: auto !important;
      }
    }

    hr{
      height: 1px;
      margin-bottom: vw(27);
      background: $grayE7;
      border: none;
    }

    .previous,
    .next{
      font-size: vw(16);
      text-align: left;
      line-height: 1.875;
      color: $font66;

      &:hover{
        cursor: pointer;
        color: $font33;
      }
    }

    .timeAndRemark span,
    .previous .time,
    .next .time{
      padding-left: vw(32);
    }

    .detailBC ::v-deep {
      .el-breadcrumb{
        span{
          &:nth-child(3){
            .el-breadcrumb__inner{
              cursor: pointer;
              font-weight: 700;
              color: $font30;

              &:hover{
                color: $yyBlue !important;
              }
            }
          }
        }
      }
    }
  }

  // -------------------------------  手机端  -------------------------------
  @media only screen and (max-width: 767px){
    position: relative;
    background: white;

    .AList{
      .eyTab{
        margin-top: vp(30);

        .eyNews{
          .content{
            padding: vp(24);
            border-radius: vp(10);
            background: #ffffff;
            box-shadow: 
              0 2px 4px rgba(0, 0, 0, 0.03),
              0 4px 12px rgba(37, 99, 175, 0.05);
            border: 1px solid rgba(37, 99, 175, 0.03);
            margin-bottom: vp(28);
            overflow: hidden;

            hr{
              margin: vp(25) 0 0;
            }

            .left{
              width: vp(200);
              height: vp(128);
              border-radius: vp(6);
              flex-shrink: 0;
            }

            

            .right{
              padding: 0;
              padding-left: vp(39);
              width: vp(446);
              max-width: 100%;
              height: auto;

              h4{
                font-size: vp(30);
                margin-bottom: vp(80);
                text-align: left;
                color: $font66;
              }

              .eyDetail{
                p,
                >div span{
                  font-size: vp(28);
                }

                >div span{
                  color: $font99;
                }
              }
            }

            &:hover{
              transform: translateY(-3px);
              box-shadow: 
                0 4px 8px rgba(37, 99, 175, 0.08),
                0 8px 24px rgba(37, 99, 175, 0.14);
              background: linear-gradient(145deg, #2563AF, #1d4f8f);
            }
          }
        }

        .moreBu{
          display: block;
          font-size: vp(24);
          padding: .77rem 2rem;
          margin: auto;
          margin-top: vp(50);
          margin-bottom: vp(60);
          outline: none;
          border: 0;
          border-radius: 8px;
          color: white;
          background: linear-gradient(180deg, rgba(37,99,175,.8), $yyBlue);
          transition: all 0.2s ease;

          span{
            display: inline-block;
            transition: all 0.2s ease;
          }

          &:hover{
            span{
              transform: translateX(vw(8));
            }
          }

          &:hover,
          &:active{
            box-shadow: 0 0 4px 5px rgba(37,99,175,.2);
          }

          &:active{
            background: linear-gradient(180deg, $yyBlue, rgba(37,99,175,.8));
          }
        }

        .onlyTextCss{
          color: $font99;
          background: transparent;
          text-shadow: none;

          &:hover,
          &:active{
            box-shadow: none;
          }

          &:active{
            background: transparent;
          }
        }
      }

      ::v-deep {
        .el-tabs__header{
          margin-bottom: vp(60);

          .el-tabs__item{
            font-size: vp(26);
            padding: 0;
            padding-bottom: vp(20);
            margin-right: vp(80);

            &:hover,
            &.is-active{
              color: $yyBlue;
              background: inherit;
              border-bottom: 2px solid $yyBlue;
              border-radius: 2px;
            }
          }

          #tab-first{
            padding-left: 0;
            margin-left: vp(83);
          }

          #tab-third{
            padding-right: 0;
          }

          .el-tabs__nav-wrap::after{
            display: none;
          }
        }
      }
    }

    .newsDetail{
      margin-top: vp(-410);
      margin-bottom: vp(82);

      h4,
      .timeAndRemark{
        text-align: left;
      }

      h4{
        font-size: vp(44);
        padding: vp(40) 0;
        margin-bottom: 0;
        line-height: 1.5;
        border-bottom: 0;
      }

      .timeAndRemark{
        font-size: vp(24);
        color: black;
      }

      .content ::v-deep {
        margin: vp(72) 0;

        p{
          margin: vp(18) 0 !important;
          line-height: 1.5 !important;
        }

        p,
        p span{
          font-size: vp(36) !important;
        }

        em{
          font-size: vp(22);
          margin-top: vp(-18);
        }

        img{
          max-width: vp(690) !important;
          width: 100% !important;
          height: auto !important;
        }
      }

      .xs-button{
        display: flex;
        justify-content: space-around;
        padding-top: vp(60);

        .previous,
        .next{
          font-size: vp(24);
          padding: vp(20) vp(80);
          color: black;
          background: $grayE6;
          border-radius: vp(5);
          transition: all 0.25s ease;

          &:focus{
            color: white;
            background: $yyBlue;
          }
        }
      }

      .detailBC{
        margin-left: vp(-32);
        margin-right: vp(-32);
        background: $blue096;

        ::v-deep {
          .el-breadcrumb{
            display: flex;
            align-items: center;
          }

          span{
            &:nth-child(3),
            &:nth-child(4){
              .el-breadcrumb__inner{
                font-size: vp(30);
                font-weight: 500 !important;
                color: white !important;
              }
            }

            &:nth-child(3){
              .el-breadcrumb__inner{
                padding: 0 vp(30);
              }

              i{
                display: none;
              }
            }

            &:nth-child(4){
              .el-breadcrumb__inner{
                display: block;
                padding: vp(15) vp(300) vp(15) vp(239);
              }
            }
          }
        }
      }
    }
  }
}
</style>